var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Component } from '@angular/core';
import { JobRole } from '../../../enums/workload/job-role';
import { WorkloadAuthService } from '../../../services/workload/workload-auth.service';
var DashboardComponent = /** @class */ (function () {
    function DashboardComponent(authService) {
        this.authService = authService;
        this.staffId = 0;
        this.viewModel = {
            title: {
                status: 'Status Overview',
                team: 'Team Overview',
                staff: 'Staff Overview',
                reports: 'Reports'
            },
            tabPermission: {
                displayTeamOverview: false,
                displayStaffOverview: false,
                displayReports: false
            }
        };
    }
    DashboardComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.authService.getCurrentUser().toPromise().then(function (staff) {
            _this.staffId = staff.id;
            if (staff.role === JobRole.Admin || staff.role === JobRole.Manager) {
                _this.viewModel.tabPermission = {
                    displayTeamOverview: staff.role === JobRole.Admin,
                    displayStaffOverview: true,
                    displayReports: true
                };
            }
        });
    };
    DashboardComponent = __decorate([
        Component({
            selector: 'workload-dashboard',
            template: require('./dashboard.component.html'),
            styles: [require('./dashboard.component.scss')]
        }),
        __metadata("design:paramtypes", [WorkloadAuthService])
    ], DashboardComponent);
    return DashboardComponent;
}());
export { DashboardComponent };
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiZGFzaGJvYXJkLmNvbXBvbmVudC5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbImRhc2hib2FyZC5jb21wb25lbnQudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7Ozs7O0FBQUEsT0FBTyxFQUFFLFNBQVMsRUFBVSxNQUFNLGVBQWUsQ0FBQztBQUdsRCxPQUFPLEVBQUUsT0FBTyxFQUFFLE1BQU0sa0NBQWtDLENBQUM7QUFDM0QsT0FBTyxFQUFFLG1CQUFtQixFQUFFLE1BQU0sa0RBQWtELENBQUM7QUFPdkY7SUFHSSw0QkFBb0MsV0FBZ0M7UUFBaEMsZ0JBQVcsR0FBWCxXQUFXLENBQXFCO1FBRDdELFlBQU8sR0FBVyxDQUFDLENBQUM7UUFFdkIsSUFBSSxDQUFDLFNBQVMsR0FBRztZQUNiLEtBQUssRUFBRTtnQkFDSCxNQUFNLEVBQUUsaUJBQWlCO2dCQUN6QixJQUFJLEVBQUUsZUFBZTtnQkFDckIsS0FBSyxFQUFFLGdCQUFnQjtnQkFDdkIsT0FBTyxFQUFFLFNBQVM7YUFDckI7WUFDRCxhQUFhLEVBQUU7Z0JBQ1gsbUJBQW1CLEVBQUUsS0FBSztnQkFDMUIsb0JBQW9CLEVBQUUsS0FBSztnQkFDM0IsY0FBYyxFQUFFLEtBQUs7YUFDeEI7U0FDSixDQUFDO0lBQ04sQ0FBQztJQUVNLHFDQUFRLEdBQWY7UUFBQSxpQkFXQztRQVZHLElBQUksQ0FBQyxXQUFXLENBQUMsY0FBYyxFQUFFLENBQUMsU0FBUyxFQUFFLENBQUMsSUFBSSxDQUFDLFVBQUEsS0FBSztZQUNwRCxLQUFJLENBQUMsT0FBTyxHQUFHLEtBQUssQ0FBQyxFQUFFLENBQUM7WUFDeEIsSUFBSSxLQUFLLENBQUMsSUFBSSxLQUFLLE9BQU8sQ0FBQyxLQUFLLElBQUksS0FBSyxDQUFDLElBQUksS0FBSyxPQUFPLENBQUMsT0FBTyxFQUFFO2dCQUNoRSxLQUFJLENBQUMsU0FBUyxDQUFDLGFBQWEsR0FBRztvQkFDM0IsbUJBQW1CLEVBQUUsS0FBSyxDQUFDLElBQUksS0FBSyxPQUFPLENBQUMsS0FBSztvQkFDakQsb0JBQW9CLEVBQUUsSUFBSTtvQkFDMUIsY0FBYyxFQUFFLElBQUk7aUJBQ3ZCLENBQUM7YUFDTDtRQUNMLENBQUMsQ0FBQyxDQUFDO0lBQ1AsQ0FBQztJQTlCUSxrQkFBa0I7UUFMOUIsU0FBUyxDQUFDO1lBQ1AsUUFBUSxFQUFFLG9CQUFvQjtZQUM5QixRQUFRLEVBQUUsT0FBTyxDQUFDLDRCQUE0QixDQUFDO1lBQy9DLE1BQU0sRUFBRSxDQUFDLE9BQU8sQ0FBQyw0QkFBNEIsQ0FBQyxDQUFDO1NBQ2xELENBQUM7eUNBSW1ELG1CQUFtQjtPQUgzRCxrQkFBa0IsQ0ErQjlCO0lBQUQseUJBQUM7Q0FBQSxBQS9CRCxJQStCQztTQS9CWSxrQkFBa0IifQ==